import { Link } from "react-router-dom";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

const highlights = [
  {
    icon: "school",
    title: "Academic Excellence",
    description: "Strong curriculum with qualified teachers delivering quality education.",
  },
  {
    icon: "church",
    title: "Christian Values",
    description: "Faith-centered environment nurturing spiritual growth and moral development.",
  },
  {
    icon: "security",
    title: "Safe Environment",
    description: "Secure, child-friendly campus where your children can learn and grow.",
  },
  {
    icon: "computer",
    title: "Modern Facilities",
    description: "Well-equipped classrooms and modern computer laboratory for digital learning.",
  },
];

function WhyChooseUsPreview() {
  return (
    <MKBox component="section" py={6} sx={{ backgroundColor: "#f8f9fa" }}>
      <Container>
        <Grid container justifyContent="center" sx={{ textAlign: "center", mb: 4 }}>
          <Grid item xs={12} md={8}>
            <MKTypography variant="h3" mb={1}>
              Why Choose Us?
            </MKTypography>
            <MKTypography variant="body1" color="text">
              Discover what makes Rose of Sharon Primary School the ideal choice for your child&apos;s education.
            </MKTypography>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          {highlights.map((item, index) => (
            <Grid item xs={12} sm={6} lg={3} key={index}>
              <MKBox
                p={3}
                textAlign="center"
                borderRadius="xl"
                sx={{
                  backgroundColor: "white",
                  boxShadow: ({ boxShadows: { md } }) => md,
                  height: "100%",
                  transition: "transform 0.3s",
                  "&:hover": {
                    transform: "translateY(-5px)",
                  },
                }}
              >
                <MKBox
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  width="4rem"
                  height="4rem"
                  borderRadius="50%"
                  sx={{
                    backgroundColor: "#006747",
                    margin: "0 auto 1rem",
                  }}
                >
                  <Icon sx={{ color: "#d32f2f", fontSize: "1.5rem" }}>{item.icon}</Icon>
                </MKBox>
                <MKTypography variant="h5" mb={1}>
                  {item.title}
                </MKTypography>
                <MKTypography variant="body2" color="text">
                  {item.description}
                </MKTypography>
              </MKBox>
            </Grid>
          ))}
        </Grid>
        <MKBox textAlign="center" mt={4}>
          <MKButton variant="gradient" color="success" component={Link} to="/why-choose-us">
            Learn More About Us
          </MKButton>
        </MKBox>
      </Container>
    </MKBox>
  );
}

export default WhyChooseUsPreview;
